//
import WarehouseModel from '@/models/Warehouse/WhWarehouse'

//
export default [
    // {
    //     text: "código(s) upc",
    //     value: "upc_codes",
    // },
    {
        text: 'alias',
        value: 'alias_name',
    },
    {
        text: 'nombre',
        value: 'name',
        component: {
            custom: 'id',
            type: 'link',
            props: {
                mapper: value => ({
                    name: 'product-update',
                        params: {
                            id: value,
                        },
                    }),
                tooltip: 'Detalle del producto',
            },
        },
    },
    {
        text: 'cantidad',
        value: 'quantity',
        format: 'number',
        align: 'right',
        input: {
            reverse: true,
            type: 'float-field',
        },
    },
    {
        text: 'precio',
        value: 'price',
        align: 'right',
        format: 'currency',
        input: {
            reverse: true,
            type: 'text-field',
        },
    },
    {
        text: 'descuento ($)',
        value: 'discount_or_charge_value',
        align: 'right',
        format: 'currency',
        input: {
            reverse: true,
            type: 'text-field',
        },
    },
    {
        text: 'descuento (%)',
        value: 'discount_or_charge_percentage',
        align: 'right',
        format: 'percentage',
        input: {
            reverse: true,
            type: 'text-field',
        },
    },
    {
        text: 'bodega',
        value: ({ wh_warehouse }) => wh_warehouse ? wh_warehouse.name : 'Sin Bodega',
        input: {
            class: 'ma-0 pa-0',
            custom: 'wh_warehouse',
            itemText: 'name',
            itemValue: 'id',
            label: 'Bodega',
            model: WarehouseModel,
            // noObject: true,
            outline: false,
            type: 'autocomplete-model',
        },
    },
]
